export const SET_ALERT = "SET_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const ALERT_TIMER = "ALERT_TIMER"